/*=========================================================================================
  File Name: moduleTheoryRatingManagement.js
  Description: Receipt Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Sib
  Author URL: http://www.organix-it.com
==========================================================================================*/

import state from './moduleLessonsRatingManagementState.js'
import mutations from './moduleLessonsRatingManagementMutations.js'
import actions from './moduleLessonsRatingManagementActions.js'
import getters from './moduleLessonsRatingManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}